export default __webpack_public_path__ + "static/media/close-gray.0b2a10d7.svg";